import { Stack } from '@sixui/ui';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { Color } from '~/components/atoms/Color';
import { QuerySkeleton } from '~/components/atoms/QuerySkeleton';
import { UpdateUserBadgeForm } from '~/components/forms/UserBadgeForm';
import { Breadcrumbs } from '~/components/molecules/Breadcrumbs';
import { Heading } from '~/components/molecules/Heading';
import { AppBreadcrumbs } from '~/components/organisms/Breadcrumbs';
import { useNavigate } from '~/components/utils/Navigation';
import { useUserBadgeQuery } from '~/lib/api/modules/UserBadges/hooks/useUserBadgeQuery';

export type IAppUpdateUserBadgePageProps = {
  appId: string;
  userBadgeId: string;
};

export const AppUpdateUserBadgePage: React.FC<IAppUpdateUserBadgePageProps> = (
  props,
) => {
  const { appId, userBadgeId } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const userBadgeQuery = useUserBadgeQuery({
    appId,
    userBadgeId,
  });
  const userBadge = userBadgeQuery.data?.userBadge;
  const parentUrl = `/apps/${appId}/badges`;

  return (
    <>
      <Helmet>
        <title>{t('AppUpdateUserBadgePage.seo.title')}</title>
      </Helmet>

      <AppBreadcrumbs appId={appId}>
        <Breadcrumbs.Action href={parentUrl}>
          {t('AppUserBadgesPage.title')}
        </Breadcrumbs.Action>
      </AppBreadcrumbs>

      <Heading
        title={
          <Stack horizontal gap={2}>
            <QuerySkeleton query={userBadgeQuery} variant="circular">
              <Color hex={userBadge?.color} />
            </QuerySkeleton>
            <QuerySkeleton query={userBadgeQuery} length={{ min: 8, max: 16 }}>
              {userBadge?.name}
            </QuerySkeleton>
          </Stack>
        }
        previousUrl={parentUrl}
      />

      <UpdateUserBadgeForm
        appId={appId}
        userBadgeId={userBadgeId}
        onSuccess={() => navigate(parentUrl)}
        cancelUrl={parentUrl}
      />
    </>
  );
};
